var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 134,
    viewBox: "0 0 169 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.68 .793)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6054904,133.067151 C135.051429,133.243534 168.320013,103.40775 168.320013,67.1110131 C168.320013,27.4220734 135.051429,-0.0113742402 98.6054904,0 L67.2407136,0 C30.3583158,-0.0113742402 0,27.428575 0,67.1110131 C0,103.415877 30.3583158,133.243534 67.2407136,133.067151 L98.6054904,133.067151",
    fill: "#006095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2301956,102.453642 L81.2301956,30.381921 C95.7473367,35.9391528 106.052976,49.964702 106.077405,66.4153432 C106.052976,82.8692353 95.7473367,96.8866575 81.2301956,102.453642 M28.7085666,66.4153432 C28.7411382,49.9744543 39.0304917,35.9570321 53.5394899,30.3835464 L53.5394899,102.439013 C39.0304917,96.8704036 28.7411382,82.8611083 28.7085666,66.4153432 M67.3872856,5.5003464 C33.6854999,5.51172418 6.37588146,32.7728797 6.36773857,66.4153432 C6.37588146,100.054556 33.6854999,127.310835 67.3872856,127.320588 C101.100471,127.310835 128.414975,100.054556 128.419861,66.4153432 C128.414975,32.7728797 101.100471,5.51172418 67.3872856,5.5003464",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinners);
export default __webpack_public_path__ + "static/media/dinners.870f0ed193c62c1c70246dbf38ba13e9.svg";
export { ForwardRef as ReactComponent };